export const BACKSPACE_SERVICES = [
  {
    id: 1,
    name: 'Project Management',
    shortName: 'project',
    features: [
      {
        id: 1,
        name: 'Register new coming project and information to be master data for other system',
        release: true
      },
      {
        id: 2,
        name: 'Record project status and communication space for estimation team and customer',
        release: true
      },
      {
        id: 3,
        name: 'Manage user authorization in the backspace system',
        release: true
      }
    ],
    to: '/services/space-project'
  },
  {
    id: 2,
    name: 'Document Management',
    shortName: 'document',
    features: [
      {
        id: 1,
        name: 'Flexible to design the workflow for individual project',
        release: true
      },
      {
        id: 2,
        name: 'Data protection via trade secret policy and watermark',
        release: true
      },
      {
        id: 3,
        name: 'Online review and comment on the PDF files',
        release: false
      }
    ],
    to: '/services/space-document'
  },
  {
    id: 3,
    name: 'Industrial IoT',
    shortName: 'iiot',
    features: [
      {
        id: 1,
        name: 'Collect existing sensor data from PLC to cloud via wireless/mobile',
        release: true
      },
      {
        id: 2,
        name: 'Small and medium scale for plant information to monitor and historical',
        release: true
      }
    ],
    to: '/services/space-iiot'
  },
  {
    id: 4,
    name: 'Secure File Storage',
    shortName: 'drop',
    features: [
      {
        id: 1,
        name: 'Data protection via trade secret policy, User authorization and multi-factors authentication',
        release: false
      },
      {
        id: 2,
        name: 'Auto watermark stamp for downloaded file',
        release: false
      },
      {
        id: 3,
        name: 'Set one time password and expired date to protect files',
        release: false
      }
    ],
    to: '/services/space-drop'
  }
];
